let placesApi: typeof google.maps.places.Place;

export const getNearbyPlaces = async (postalCodeBounds?: google.maps.LatLngBounds) => {
  if (!postalCodeBounds) {
    return;
  }

  if (!placesApi) {
    const { Place } = (await google.maps.importLibrary('places')) as google.maps.PlacesLibrary;
    placesApi = Place;
  }

  const { places } = await placesApi.searchNearby({
    locationRestriction: {
      center: {
        lat: postalCodeBounds.getCenter().lat(),
        lng: postalCodeBounds.getCenter().lng(),
      },
      radius: 2000,
    },
    fields: ['addressComponents', 'formattedAddress'],
    rankPreference: google.maps.places.SearchNearbyRankPreference.DISTANCE,
    maxResultCount: 10,
  });

  return places;
};
